<template>
  <v-container fluid>
    <ValidationObserver ref="observer">
      <v-dialog
        v-model="dialog"
        max-width="70%"
        persistent
        transition="fade-transition"
      >
        <v-btn
          slot="activator"
          color="primary"
          dark
          class="mb-2"
          @click="addEntry"
        >
          New Term
        </v-btn>
        <v-card>
          <v-title>{{ isUpdate ? 'Edit' : 'New' }} Terms & Conditions</v-title>
          <v-card-text>
            <v-form v-model="valid" lazyValidation>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs3>
                    <ValidationProvider
                      name="Term Order"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="editedItem.termOrder"
                        label="Term Order"
                        name="termOrder"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>

                  <v-flex xs3>
                    <ValidationProvider
                      name="Section"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="section"
                        v-model="editedItem.section"
                        label="Section"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs3>
                    <ValidationProvider
                      name="Heading"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="heading"
                        v-model="editedItem.heading"
                        label="Heading"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>

                  <v-flex xs3>
                    <ValidationProvider
                      name="Extra Display Conditions"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="extraDisplayConditions"
                        v-model="editedItem.extraDisplayConditions"
                        label="Extra Display Conditions"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12>
                    <div>
                      <edit-item
                        v-if="dialog"
                        ref="termsTable"
                        :termConditionID="editedItem.id"
                        :editedSectionIndex="editedIndex"
                        :section="editedItem.section"
                        :isAdding="isAdding"
                        :termItems="filteredTermItems"
                        @editing="editing = true"
                        @saved="saved"
                        @refresh="refreshItem"
                      ></edit-item>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <message-alert :component="message"></message-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="save" :disabled="editing">
              Save
            </v-btn>
            <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div>
        <v-layout row>
          <v-flex xs4>
            <v-text-field
              name="Search"
              label="Search"
              v-model="SearchText"
              append-icon="search"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>

      <ag-grid-vue
        :style="{ width, height }"
        domLayout="autoHeight"
        class="ag-theme-balham mb-4"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="filteredRows.filter(x => x.id !== 0)"
        pagination
        :paginationPageSize="10"
        :frameworkComponents="frameworkComponents"
        @grid-ready="onFirstDataRendered"
      ></ag-grid-vue>
      <v-flex sm12 md12 lg12>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapTermsConditionsFields,
  mapTermsConditionsMultiRowFields,
} from '@/store/modules/orders';
import editItem from '@/components/termsAndConditions/edit-item';
const {
  mapActions: mapTermsConditionsActions,
  mapMutations: mapTermsConditionsMutations,
} = createNamespacedHelpers(`orders/termsConditions`);
import { httpError } from '@/models/httpError';
import { Term } from '@/models/term';
import { TermItem } from '@/models/termItem';
import { AgGridVue } from 'ag-grid-vue';
import TableActions from '@/components/admin/fieldOptions/tableActions';

export default {
  name: 'maintainTerms',
  components: { editItem, AgGridVue, TableActions },
  data: () => ({
    valid: true,
    dialog: false,
    editedItem: new Term(),
    editedIndex: 0,
    editing: false,
    isAdding: false,
    SearchText: null,
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,
    headers: [
      {
        text: 'Term ID',
        align: 'right',
        sortable: true,
        value: 'id',
      },

      {
        text: 'Section',
        align: 'left',
        sortable: true,
        value: 'section',
      },
      {
        text: 'Heading',
        align: 'left',
        sortable: true,
        value: 'heading',
      },
      {
        text: 'Term Order',
        align: 'right',
        sortable: true,
        value: 'termOrder',
      },

      {
        text: 'Extra Conditions',
        align: 'left',
        sortable: true,
        value: 'extraDisplayConditions',
      },
      {
        text: 'Actions',
      },
    ],
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: null,
    gridApi: null,
    frameworkComponents: null,
    height: '100%',
    width: '100%',
    isUpdate: false,
    termItems: []
  }),

  computed: {
    ...mapTermsConditionsFields(['message']),
    ...mapTermsConditionsMultiRowFields(['rows']),
    filteredRows: function() {
      let vm = this;
      if (!vm.rows) return [];
      return vm.rows.filter(this.isValid);
    },
    filteredTermItems: function() {
      let vm = this
      if (vm.termItems.length == 0) return []

      return vm.termItems
    }
  },
  methods: {
    ...mapTermsConditionsActions([
      'getTerms',
      'updateTerms',
      'setMessage',
      'removeTerm',
      'deleteTermsCondition',
      'getTermItems'
    ]),
    ...mapTermsConditionsMutations(['addRow', 'removeTerm']),
    saved() {
      this.editing = false;
      this.isAdding = false;
    },
    setContent(val) {
      this.$refs.tm.editor.setContent(val);
    },
    addEntry() {
      this.setMessage(new httpError());
      this.isAdding = true;
      this.isUpdate = false;
    },
    formatProp(el) {
      if (el.item[el.value.value]) {
        if (el.value.abstract) {
          return (
            el.item[el.value.value].toString().substring(0, el.value.abstract) +
            '...'
          );
        } else {
          return el.item[el.value.value];
        }
      }
    },
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      vm.getTerms().then(() => {
        vm.loading = false;
      });
    },
    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.rows.indexOf(item);

      this.editedItem = this.rows[this.editedIndex];

      this.getTermItems(item.id).then((data) => {
        this.termItems = data
        this.dialog = true;
      })
    },
    refreshItem(termItemData) {
      let vm = this;

      vm.getTermItems(termItemData.termItem.termsConditionsID).then((data) => {
        vm.termItems = data
        vm.getDataFromApi();
      })
    },
    deleteItem(item) {
      this.setMessage(new httpError());
      //const index = this.rows.indexOf(item);
      let answer = confirm('Are you sure you want to delete this item?');
      if (answer) {
        this.deleteTermsCondition(item.id).then(data => {
          // let refreshPayload = { termItem: data, isDelete: true };
          // this.$emit("refresh", refreshPayload);
        });
        // this.removeTerm(this.rows[index].id).then(data => {
        //   //this.items.splice(index, 1);
        // });
      }
    },

    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },

    close() {
      this.dialog = false;
      let nullTerm = this.rows.filter(x => x.id === 0);

      if (nullTerm.length > 0) this.removeTerm(nullTerm[0].id);

      setTimeout(() => {
        this.termItems = [];
        this.editedItem = Object.assign({}, new Term());
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let vm = this;
      vm.updateTerms({
        termIndex: vm.editedIndex,
        isUpdate: this.isUpdate,
        editedItem: this.editedItem,
      })
        .then(() => {
          vm.getDataFromApi();
          vm.close();
        })
        .catch(() => vm.close());
    },
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
  },
  mounted() {
    this.getDataFromApi();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Term ID',
        field: 'id',
        sortable: true,
        maxWidth: 120,
      },
      {
        headerName: 'Section',
        field: 'section',
        sortable: true,
        maxWidth: 250,
      },
      {
        headerName: 'Heading',
        field: 'heading',
        sortable: true,
      },
      {
        headerName: 'Term Order',
        field: 'termOrder',
        sortable: true,
        maxWidth: 120,
      },
      {
        headerName: 'Extra Conditions',
        field: 'extraDisplayConditions',
        sortable: true,
        filter: true,
        maxWidth: 160,
      },
      {
        headerName: 'Actions',
        field: 'mainAction',
        maxWidth: 120,
        cellRenderer: 'tableActions',
        cellRendererParams: {
          clicked: function(param) {
            vm.isUpdate = true;
            switch (param.type) {
              case 'edit':
                vm.editItem(param);
                break;
              case 'delete':
                vm.deleteItem(param);
                break;
            }
          },
        },
      },
    ];

    vm.frameworkComponents = {
      tableActions: TableActions,
    };

    vm.defaultColDef = {
      autoHeight: true,
    };
  },
};
</script>
<style scoped>
.editor {
  max-width: 75vh;
}
</style>
